module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/second_288f6f654369b10fed853420db3a74ab.png";